export const getAssignableLeadTeamIds = (
  ownerTeamId: string | null | undefined,
  fallbackTeamIds: string[],
): string[] => (ownerTeamId == null ? fallbackTeamIds : [ownerTeamId]);

export const getLeadAssignmentIdsToRemove = (
  lead: {
    owner_team_id?: string | null;
    lead_agents: { id: string; user_id: string }[];
  },
  brokerId: string,
  teamMemberIds: string[],
): string[] => {
  // Profile assignments remain as history, even after reassignment.
  if (lead.owner_team_id != null) {
    return [];
  }
  return lead.lead_agents
    .filter(
      agent =>
        agent.user_id !== brokerId && teamMemberIds.includes(agent.user_id),
    )
    .map(agent => agent.id);
};

export const canAssignLeadToBrokerTeams = (
  ownerTeamId: string | null | undefined,
  brokerTeamIds: Iterable<string>,
): boolean => {
  if (ownerTeamId == null) {
    return true;
  }

  for (const teamId of brokerTeamIds) {
    if (teamId === ownerTeamId) {
      return true;
    }
  }

  return false;
};
